import React from 'react';
import { Helmet } from 'react-helmet';
import { WebPageSchema, BreadcrumbSchema } from '../components/SEOStructuredData';
import { Container, Title, Text, Grid } from '@mantine/core';
import { motion } from 'framer-motion';
import { IconMail, IconPhone, IconMapPin } from '@tabler/icons-react';
import ContactForm from '../components/ContactForm';
import classes from './Contact.module.css';

export default function Contact() {
  // Define breadcrumb items for structured data
  const breadcrumbItems = [
    { name: 'Home', url: 'https://optifyne.com/' },
    { name: 'Contact', url: 'https://optifyne.com/contact' }
  ];

  return (
    <>
      {/* SEO Structured Data */}
      <Helmet>
        <title>Contact Optifyne - Get in Touch With Our Team</title>
        <meta name="description" content="Contact Optifyne's team of process automation experts. We specialize in secure solutions for government and enterprise using Nintex K2 and Power Platform." />
      </Helmet>
      <WebPageSchema 
        title="Contact Optifyne - Get in Touch With Our Team"
        description="Contact Optifyne's team of process automation experts. We specialize in secure solutions for government and enterprise using Nintex K2 and Power Platform."
        url="https://optifyne.com/contact"
      />
      <BreadcrumbSchema items={breadcrumbItems} />
    <div className={classes.wrapper}>
      <Container size="xl" className={classes.container}>
        <Grid gutter="xl" align="center" style={{ paddingTop: '2rem', minHeight: 'calc(100vh - 9rem)' }}>
          <Grid.Col span={{ base: 12, md: 5 }} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className={classes.infoSection}
            >
              <Title className={classes.title}>
                Get in touch
              </Title>
              <Text className={classes.subtitle}>
                We'd love to hear from you
              </Text>
              <Text
            className={classes.tagline}
            mt="sm"
            fw={600}
            fs="italic"
            c="dimmed"
          >
            Simplifying Complexity, Amplifying Results
          </Text>
              <div className={classes.contactInfo}>
                <div className={classes.contactItem}>
                  <IconPhone size={24} stroke={1.5} className={classes.contactIcon} />
                  <div>
                    <Text className={classes.contactLabel}>Phone</Text>
                    <Text className={classes.contactValue}>+44 (0) 330 043 7550</Text>
                  </div>
                </div>
                
                <div className={classes.contactItem}>
                  <IconMail size={24} stroke={1.5} className={classes.contactIcon} />
                  <div>
                    <Text className={classes.contactLabel}>Email</Text>
                    <Text className={classes.contactValue}>enquiries@optifyne.com</Text>
                  </div>
                </div>
                
                <div className={classes.contactItem}>
                  <IconMapPin size={24} stroke={1.5} className={classes.contactIcon} />
                  <div>
                    <Text className={classes.contactLabel}>Location</Text>
                    <Text className={classes.contactValue}>Mildenhall, Suffolk, United Kingdom</Text>
                    
                  </div>
                </div>
              </div>
            </motion.div>
          </Grid.Col>
          
          <Grid.Col span={{ base: 12, md: 7 }} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className={classes.formWrapper}
            >
              <ContactForm />
            </motion.div>
          </Grid.Col>
        </Grid>
      </Container>
    </div>
    </>
  );
}

